import makeApi from "../../libs/axios/api";
import {
  OrderHistoryPayload,
  type OrderDetailsList,
} from "../../types/orderhistory";
const apiPromise = makeApi();

const getOrderHistory = async (
  order: OrderHistoryPayload
): Promise<OrderDetailsList> => {
  const api = await apiPromise;

  const params = new URLSearchParams({
    FromDate: order.FromDate || "",
    ToDate: order.ToDate || "",
    AccountNo: order.AccountNo || "",
    PageNumber: order.PageNumber?.toString() || "1",
    PageSize: order.PageSize?.toString() || "10",
    OrderByColumn: order.OrderByColumn || "",
    OrderBy: order.OrderBy || "",
    RO: order.RoNo || "",
    PO: order.PoNo || "",
    CompanyCode: order.CompanyCode || "",
  });
  if (order.Status.length > 0) {
    order.Status.forEach((id) => params.append("Status", id.toString()));
  } else {
    params.append("Status", "1");
  }

  const path = `/order/history?${params.toString()}`;

  return api.get(path).then((response) => {
    return response.data as OrderDetailsList;
  });
};


export default getOrderHistory;
